/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Sucker.vue?vue&type=template&id=3eecc085&"
import script from "./Sucker.vue?vue&type=script&lang=js&"
export * from "./Sucker.vue?vue&type=script&lang=js&"
import style0 from "./Sucker.vue?vue&type=style&index=0&id=3eecc085&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports